var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"images"},_vm._l((_vm.data),function(img){return _c('img',{key:img.id,attrs:{"src":img.img_url}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }